
<template>
  <div
    class="modal fade"
    id="dropshipDetail"
    tabindex="-1"
    role="dialog">
    <div
      class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
      role="document">
      <div class="modal-content">
        <div class="modal-body animate__animated animate__fadeIn animate__faster">
          <button
            type="button"
            class="btn-close float-end"
            data-bs-dismiss="modal"/>
          <MoreInfo
            v-if="viewType == 'moreInfo'"
            :showTimes="true"
            :mfg="mfg"/>
          <VendorNotes
            v-if="viewType == 'notes'"
            :showTimes="true"
            :mfg="mfg"/>
          <ProductDetail v-if="viewType == 'product'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import MoreInfo from './MoreInfo.vue';
  import ProductDetail from './ProductDetail.vue';
  import VendorNotes from '../../step3/components/VendorNotes.vue';

  // Initialize
  const store = useStore()
  const props = defineProps(['mfg'])
  
  // Computed
  const viewType = computed(()=>{
    return store.getters.dropshipModalViewType
  })

</script>